import axios from 'axios';

import { logError } from '../../infrastructure/error-handling.js';

class AboutUsService {
	getData(language) {
		return axios
			.get(
				`${
					process.env.REACT_APP_API_ENDPOINT
				}/api/singletons/get/aboutUs?lang=${language}`,
			)
			.then(res => res.data)
			.catch(logError);
	}
}

export default new AboutUsService();
